module.exports = __webpack_public_path__ + "static/media/foto4.6c5f336f.png";